import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { CommonStyles } from '../styles/Styles';
import { StyleSheet, css } from 'aphrodite';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      className={css(CommonStyles.headerMemberCountContainer)}
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export function SimpleTabs({ numberOfTabs, handleTabPanelChange }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleTabPanelChange(newValue)
  };

  return (
    <div >
      <AppBar position="static">
        <Tabs
          variant="fullWidth"
          value={value}
          TabIndicatorProps={{ style: { backgroundColor: "white" , width:'50%'} }}
          onChange={handleChange}
          centered
          aria-label="nav tabs example"
        >
          {
            numberOfTabs.map((val, i) => {
              return <LinkTab label={val}  {...a11yProps(val)} />
            })
          }

        </Tabs>
      </AppBar>

    </div>
  );
}
